let config

const maintenancemode = false

const configlive = {
  mode: 'live',
  front_url: 'https://markii.gdq.se',
  base_url: 'https://api.gdq.se',
  report_url: 'https://reports.gdq.se',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZmlyc3RfbmFtZSI6IiIsImZhbWlseV9uYW1lIjoiIiwiZW1haWwiOiIiLCJlbnRlcnByaXNlX2lkIjowLCJldmVudHNfYWRtaW5fb25seSI6MCwiZXhwIjoxODI1MjUyNzU1fQ.YOrVQz_5SBtZS0cNwOuDXCGUz5oax6VUFT-XK6l1VMQ',
  maintenancemode,
  timeZone: 'Europe/Berlin'
}

const configtest = {
  maintenancemode,
  mode: 'test',
  front_url: 'http://localhost:8080',
  base_url: 'http://ubuntu-prodesk.local/gdq_api',
  report_url: 'http://ubuntu-prodesk.local/gdq_reports',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZmlyc3RfbmFtZSI6IiIsImZhbWlseV9uYW1lIjoiIiwiZW1haWwiOiIiLCJlbnRlcnByaXNlX2lkIjowLCJldmVudHNfYWRtaW5fb25seSI6MCwiZXhwIjoxODI1MjUyNzU1fQ.YOrVQz_5SBtZS0cNwOuDXCGUz5oax6VUFT-XK6l1VMQ',
  timeZone: 'Europe/Berlin'
}

const configstage = {
  mode: 'stage',
  front_url: 'https://markii.test.gdq.se',
  base_url: 'https://api.test.gdq.se',
  report_url: 'https://reports.test.gdq.se',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZmlyc3RfbmFtZSI6IiIsImZhbWlseV9uYW1lIjoiIiwiZW1haWwiOiIiLCJlbnRlcnByaXNlX2lkIjowLCJldmVudHNfYWRtaW5fb25seSI6MCwiZXhwIjoxODI1MjUyNzU1fQ.YOrVQz_5SBtZS0cNwOuDXCGUz5oax6VUFT-XK6l1VMQ',
  maintenancemode,
  timeZone: 'Europe/Berlin'
}

config = configlive
const location = window.location

if (location.host.indexOf('test') > 0) {
  config = configstage
}
if (location.host.indexOf('gdq.se') < 0) {
  config = configtest
  if (location.port !== '') {
    config = {
      ...configtest,
      front_url: location.origin
    }
  }
}
console.log({ config} ) 
export { config }
